import React, { useState, useRef } from 'react';
import { usePanels } from './App';

function IntroPanel() {
  const { swapPanel } = usePanels();
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  
  const handleLearnMore = () => {
    swapPanel('menu', 'leftPanel');
  };

  const handleGetInTouch = () => {
    swapPanel('contact', 'rightPanel');
  };

  const toggleSound = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(!isMuted);
    }
  };

  const handleVideoLoad = () => {
    setIsLoading(false);
  };
  
  return (
    <div id="introPanel" className="Panel Panel-left custom-left-panel-bg">
      <div className="left-panel-content">

        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 24, position: 'relative', height: '50%' }}>
          {isLoading && (
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: '18px',
              color: '#fff',
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              padding: '12px 24px',
              borderRadius: '8px',
              zIndex: 10
            }}>
              Loading...
            </div>
          )}
          <video
            ref={videoRef}
            src="/psycode_ad_960.mp4"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            onCanPlay={handleVideoLoad}
            style={{ width: '100%', maxWidth: 768, height: 'auto', display: isLoading ? 'block' : 'block' }}
          />
        </div>

        {!isLoading && (
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
            <button onClick={toggleSound} className="left-panel-btn" style={{ background: 'none', color: '#333' }}>
              {isMuted ? '🔇 Play sound' : '🔊 Mute sound'}
            </button>
          </div>
        )}
        <div style={{ width: '100%', display: 'none', justifyContent: 'center', marginBottom: 24 }}>
          <img src="/psycode_logo.png" alt="Psycode Logo" style={{ maxWidth: 180, width: '100%', height: 'auto' }} />
        </div>
        <h1 className="left-panel-title">Psycode</h1>
        <h2 className="left-panel-subtitle">Innovating Technology for Social Good</h2>
        <div>
          <button className="left-panel-btn" onClick={handleLearnMore}>Learn more</button>
          <button className="left-panel-btn" onClick={handleGetInTouch}>Get in touch</button>
        </div>
      </div>
    </div>
  );
}

export default IntroPanel; 